import { useMemo } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import styled, { createGlobalStyle } from "styled-components"
import { useJsApiLoader } from '@react-google-maps/api'

import ProductStore from '../productStore'
import OrderButton from './Orders'
import Slideshow from './Slideshow'
import Map from './Map/Map'
import SupportedCounties from './CountyCoordinates/SupportedCounties'
import MissionStatement from './MissionStatement'
import TrailerPottySlideshow from './TrailerPottySlideshow'
import ContactPage from './ContactPage'

function Home() {

  const showMaintenanceMessage = false;
  const libraries = useMemo(() => ['places'], [])

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  })

  return (
    <>
      <GlobalStyle />
      <AppContainer>

        {showMaintenanceMessage && (
          <OutageDiv>
            <OutageText>The Site is currently under maintenance and some features may not work</OutageText>
          </OutageDiv>
        )}

        <SlideshowContainer>
          <Slideshow />
        </SlideshowContainer>

        <MissionStatement />

        <OuterMapContainer>
          {!isLoaded ? <div><p>Loading...</p></div> :
            <InnerMapContainer>
              <MapContainer>
                <Map />
              </MapContainer>
              <SupportedCountiesContainer>
                <SupportedCounties />
              </SupportedCountiesContainer>
            </InnerMapContainer>}
        </OuterMapContainer>

        <TrailerPottyContainer>
          <TrailerPottyHeaderContainer>
            <TrailerPottyHeader>Luxury Four Stall Restroom Trailer</TrailerPottyHeader>
          </TrailerPottyHeaderContainer>

          <TrailerPottySlideshowContainer>
            <TrailerPottySlideshow />
          </TrailerPottySlideshowContainer>

          <TrailerDescriptionDiv>
            <TrailerDescription>This spacious 4-Door, 4-Station restroom trailer has a delightful interior and enough capacity to service up to 350 guests. A true first-class experience!</TrailerDescription>
          </TrailerDescriptionDiv>
        </TrailerPottyContainer>

        <AnimatePresence>
          <BodyContainer initial={{ height: '100px' }} animate={{ height: 100 }} transition={{ duration: 0.5 }}>
            <PricesButtonsContainer>
              <OrderContainer>
                <OrderButton />
              </OrderContainer>
            </PricesButtonsContainer>

            <PricingContainer>
              <ProductStore />
            </PricingContainer>
          </BodyContainer>
        </AnimatePresence>

        <AnimatePresence>
          <ContactContainer>
            <ContactPage />
          </ContactContainer>
        </AnimatePresence>

        <FooterContainer>
          <CopyrightContainer>
            <CopyrightText>Copyright ©2023 Wildcat Porta-Potti</CopyrightText>
          </CopyrightContainer>
        </FooterContainer>

      </AppContainer>
    </>
  );
}

const GlobalStyle = createGlobalStyle`
  body {
    overflow-x: hidden;
    max-width: 100%;
    width: 100%;
  }
`

const AppContainer = styled.div`
  height: 100vh;
  overflow: scroll;
  position: relative;
  background-color: #2b6cd4;
  background-image: -webkit-linear-gradient(40deg, #013A6B 50%, #004E95 50%);
`

const OutageDiv = styled.div`
  margin-bottom: 20px;
  text-align: center;
  color: white;
  height: 40px;
`

const OutageText = styled.p`
  font-size: 24px;
  @media(max-width: 800px){
    font-size: 18px;
    height: 55px;
  }
  @media(max-width: 500px){
    font-size: 12px;
    height: 55px;
  }
`

const BodyContainer = styled(motion.div)`
  margin-top: 10%;
`

const SlideshowContainer = styled.div`
  width: 95vw;
  height: 60%;
  margin: auto;
  margin-bottom: 100px;
  @media(max-width: 800px){
    font-size: 18px;
    height: 40%;
  }
`

const PricesButtonsContainer = styled.div`
  display: flex;
  width: 100%; 
  margin: auto;  
  margin-bottom: 2%; 
`

const OrderContainer = styled.div`
  margin: auto;
  width: 100%;
`

const PricingContainer = styled.div`
  height: 300px;
  margin: 25px;
`

const OuterMapContainer = styled.div`
  margin-top: 10%;
  padding: 10px 0;
`

const InnerMapContainer = styled.div`
  height: 60vh;
  display: flex;
  @media(max-width: 800px){
    display: inline;
  }
`

const MapContainer = styled.div`
  width: 60vw;
  margin-left: 10%;
  @media(max-width: 1300px){
    width: 80vw;
    height: 40vh;
    margin: auto;
  }
`

const TrailerPottyContainer = styled.div`
  text-align: center;
`

const TrailerPottyHeaderContainer = styled.div`
  margin-top: 10%;
  color: white;
  display: flex;
  justify-content: center;
`

const TrailerPottyHeader = styled.p`
  font-size: 32px;
  @media(max-width: 800px){
    font-size: 14px;
  }
`

const TrailerPottySlideshowContainer = styled.div`

`

const TrailerDescriptionDiv = styled.div`
  width: 30%;
  margin: auto;
  margin-top: 5%;
  @media(max-width: 800px){
    width: 80%;
  }
`

const TrailerDescription = styled.p`
  color: white;
  padding: 10px;
`

const SupportedCountiesContainer = styled.div`
  width: 100vw;
  overflow-y: auto;
`

const ContactContainer = styled(motion.div)`
  margin: 25px;
  margin-top: 10%;
`

const FooterContainer = styled(motion.div)`

`

const CopyrightContainer = styled.div`
  text-align: center;
  margin-bottom: 25px;
`

const CopyrightText = styled.text`
  color: white;
  font-size: 24px;
`

export default Home;
